import React from 'react';
import Search_Comp from '../../Components/Search/Search';

function Search() {
  return (
    <Search_Comp />
  )
}

export default Search;